import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const BeatIndicators = ({ beatsPerMeasure, currentBeat, beatAccents, onToggleBeatAccent }) => {
  const { t } = useLanguage();

  const getGridClasses = (beats) => {
    if (beats <= 3) return 'flex justify-center items-center gap-4';
    if (beats === 4) return 'grid grid-cols-2 gap-4 justify-items-center max-w-[200px] mx-auto';
    if (beats === 6) return 'grid grid-cols-3 gap-3 justify-items-center max-w-[240px] mx-auto';
    return 'flex justify-center items-center gap-2 flex-wrap';
  };

  // 特殊布局處理
  const renderBeats = () => {
    if (beatsPerMeasure === 5) {
      return (
        <div className="space-y-4">
          {/* 上排：1,2,3 */}
          <div className="flex justify-center items-center gap-4">
            {[0, 1, 2].map(index => (
              <button
                key={index}
                onClick={() => onToggleBeatAccent(index)}
                className={`w-16 h-16 rounded-full font-bold text-xl transition-all duration-200 transform hover:scale-110 ${
                  currentBeat === index
                    ? beatAccents[index]
                      ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg scale-110'
                      : 'bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg scale-110'
                    : beatAccents[index]
                    ? 'bg-yellow-200 text-yellow-800 border-2 border-yellow-400'
                    : 'bg-purple-200 text-purple-800 border-2 border-purple-400'
                }`}
                title={t('beatIndicatorHelp')}
              >
                {index + 1}
              </button>
            ))}
          </div>
          {/* 下排：4,5 */}
          <div className="flex justify-center items-center gap-4">
            {[3, 4].map(index => (
              <button
                key={index}
                onClick={() => onToggleBeatAccent(index)}
                className={`w-16 h-16 rounded-full font-bold text-xl transition-all duration-200 transform hover:scale-110 ${
                  currentBeat === index
                    ? beatAccents[index]
                      ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg scale-110'
                      : 'bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg scale-110'
                    : beatAccents[index]
                    ? 'bg-yellow-200 text-yellow-800 border-2 border-yellow-400'
                    : 'bg-purple-200 text-purple-800 border-2 border-purple-400'
                }`}
                title={t('beatIndicatorHelp')}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      );
    }

    if (beatsPerMeasure === 6) {
      return (
        <div className="space-y-4">
          {/* 上排：1,2,3 */}
          <div className="flex justify-center items-center gap-4">
            {[0, 1, 2].map(index => (
              <button
                key={index}
                onClick={() => onToggleBeatAccent(index)}
                className={`w-16 h-16 rounded-full font-bold text-xl transition-all duration-200 transform hover:scale-110 ${
                  currentBeat === index
                    ? beatAccents[index]
                      ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg scale-110'
                      : 'bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg scale-110'
                    : beatAccents[index]
                    ? 'bg-yellow-200 text-yellow-800 border-2 border-yellow-400'
                    : 'bg-purple-200 text-purple-800 border-2 border-purple-400'
                }`}
                title={t('beatIndicatorHelp')}
              >
                {index + 1}
              </button>
            ))}
          </div>
          {/* 下排：4,5,6 */}
          <div className="flex justify-center items-center gap-4">
            {[3, 4, 5].map(index => (
              <button
                key={index}
                onClick={() => onToggleBeatAccent(index)}
                className={`w-16 h-16 rounded-full font-bold text-xl transition-all duration-200 transform hover:scale-110 ${
                  currentBeat === index
                    ? beatAccents[index]
                      ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg scale-110'
                      : 'bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg scale-110'
                    : beatAccents[index]
                    ? 'bg-yellow-200 text-yellow-800 border-2 border-yellow-400'
                    : 'bg-purple-200 text-purple-800 border-2 border-purple-400'
                }`}
                title={t('beatIndicatorHelp')}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      );
    }

    // 其他拍數的正常處理
    return (
      <div className={getGridClasses(beatsPerMeasure)}>
        {Array.from({ length: beatsPerMeasure }, (_, index) => (
          <button
            key={index}
            onClick={() => onToggleBeatAccent(index)}
            className={`w-16 h-16 rounded-full font-bold text-xl transition-all duration-200 transform hover:scale-110 ${
              currentBeat === index
                ? beatAccents[index]
                  ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg scale-110'
                  : 'bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg scale-110'
                : beatAccents[index]
                ? 'bg-yellow-200 text-yellow-800 border-2 border-yellow-400'
                : 'bg-purple-200 text-purple-800 border-2 border-purple-400'
            }`}
            title={t('beatIndicatorHelp')}
          >
            {index + 1}
          </button>
        ))}
      </div>
    );
  };

  // 圖例與提示文字的內聯顯示
  const renderLegendAndHelp = () => (
    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-4 text-sm text-gray-600 dark:text-gray-300">
      <div className="flex items-center space-x-2">
        <div className="w-4 h-4 rounded-full bg-yellow-200 border-2 border-yellow-400"></div>
        <span>{t('accentBeat') || '重拍'}</span>
      </div>
      <div className="flex items-center space-x-2">
        <div className="w-4 h-4 rounded-full bg-purple-200 border-2 border-purple-400"></div>
        <span>{t('regularBeat') || '輕拍'}</span>
      </div>
      <span className="text-gray-500 dark:text-gray-400">
        ({t('beatIndicatorHelp')})
      </span>
    </div>
  );

  return (
    <div className="text-center">
      <h3 className="text-lg font-semibold mb-6 text-gray-700 dark:text-gray-300">
        {t('beatIndicators')}
      </h3>
      {renderBeats()}
      {renderLegendAndHelp()}
    </div>
  );
};

export default BeatIndicators;